import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { PageHeader } from '../components/PageParts';
import { initials } from '../utils/format';
import { Mail, Phone, Briefcase, Shield } from 'lucide-react';

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div>
      <PageHeader title="Meu Perfil" subtitle="Suas informações pessoais" />
      <div className="rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 p-6 max-w-2xl">
        <div className="flex items-center gap-4">
          <div className="h-20 w-20 rounded-full bg-brand text-white flex items-center justify-center text-2xl font-bold">{initials(user.name)}</div>
          <div>
            <h2 className="text-xl font-bold">{user.name}</h2>
            <p className="text-sm text-neutral-500">{user.role}</p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
          <div className="flex items-center gap-3 p-3 rounded-lg bg-neutral-50 dark:bg-neutral-950"><Mail className="h-5 w-5 text-brand" /><div><p className="text-xs text-neutral-500">Email</p><p className="text-sm font-medium">{user.email}</p></div></div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-neutral-50 dark:bg-neutral-950"><Phone className="h-5 w-5 text-brand" /><div><p className="text-xs text-neutral-500">Telefone</p><p className="text-sm font-medium">{user.phone || '-'}</p></div></div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-neutral-50 dark:bg-neutral-950"><Briefcase className="h-5 w-5 text-brand" /><div><p className="text-xs text-neutral-500">Cargo</p><p className="text-sm font-medium">{user.position || '-'}</p></div></div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-neutral-50 dark:bg-neutral-950"><Shield className="h-5 w-5 text-brand" /><div><p className="text-xs text-neutral-500">Perfil</p><p className="text-sm font-medium">{user.role}</p></div></div>
        </div>
      </div>
    </div>
  );
}
